module.exports = __webpack_public_path__ + "static/img/notImg.ffc9fa8.png";